import React from 'react';
import DataTable from '../../../common/data_display/DataTable';
import { formatDate } from '../../../common/data_display/utils';

export default function AdmDatesTable(props) {
  const { d0_date, d2_date, timestamp } = props;

  const rows = [
    { name: 'Report Date', value: timestamp ? formatDate(new Date(timestamp)) : undefined },
    { name: 'D0 Date', value: d0_date ? formatDate(new Date(d0_date)) : undefined },
    { name: 'D2 Date', value: d2_date ? formatDate(new Date(d2_date)) : undefined },
  ];

  return <DataTable title='Dates' rows={rows} />
}
